import logoMark from '../../assets/logo-mark.svg';

const FOOTER_LINKS: Array<{ label: string; href: string; external: boolean }> = [
  { label: 'Platform', href: '/#platform', external: false },
  { label: 'Developers', href: '/#developers', external: false },
  { label: 'Team', href: '/team', external: false },
  { label: 'Documentation', href: 'https://docs.briefcaseai.org/', external: true },
  { label: 'GitHub', href: 'https://github.com/briefcasebrain/briefcase-ai-sdk', external: true },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/briefcasebrains-ai/', external: true },
];

/** Ink block, continuous with the closing CTA band above it. */
export function Footer() {
  return (
    <footer className="bg-ink px-5 pb-12 pt-14 sm:px-8">
      <div className="mx-auto flex max-w-[1120px] flex-wrap items-center justify-between gap-6 border-t border-rule-invert pt-10">
        <div className="flex items-center gap-3">
          <img src={logoMark} alt="" className="h-8 w-8 rounded-md object-cover" />
          <span className="text-[17px] font-semibold tracking-[-0.01em] text-paper">
            Briefcase AI
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {FOOTER_LINKS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              target={item.external ? '_blank' : undefined}
              rel={item.external ? 'noopener noreferrer' : undefined}
              className="text-[15px] font-medium tracking-[0.0175em] text-[rgba(253,253,252,0.7)] no-underline transition-colors hover:text-paper"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="flex flex-col items-end gap-1 text-right text-[14px] tracking-[0.0175em] text-[rgba(253,253,252,0.55)]">
          <a href="mailto:support@briefcaseai.org" className="text-[rgba(253,253,252,0.72)] no-underline hover:text-paper">
            support@briefcaseai.org
          </a>
          <span>© 2026 Briefcase AI</span>
        </div>
      </div>
    </footer>
  );
}
